import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'

import type { GetArrestedType } from '../../../types/GetArrested'
import type { GetOffenseType } from '../../../types/GetOffense' 
import type { GetRelatedOffenseType } from '../../../types/GetRelatedOffense'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface ArresteesProps {
    arrestees: GetArrestedType[];
    offenses: GetOffenseType[];
    relatedOffenses: GetRelatedOffenseType[];
}

const Arrestees: React.FC<ArresteesProps> = ({ arrestees = [], offenses = [], relatedOffenses = [] }) => {

    return (
        <ThemeProvider theme={theme} >
            {arrestees.length > 0 && (
                arrestees.map((arrestee, index) => {
                    const arresteeRelatedOffenses = relatedOffenses
                        .filter(offense => offense.personId === arrestee.personId)
                        .map(relatedOffense => offenses.find(offense => offense.offenseId === relatedOffense.offenseId));

                    return (
                        <Table key={index} cellPadding="0" cellSpacing="0">
                            <tbody>
                                <HeaderRow>
                                    <td>ARRESTEE : {arrestee.name}</td>
                                </HeaderRow>
                                <tr>
                                    <td>
                                        <Table key={index} cellPadding="2" cellSpacing="0">
                                            <tbody>
                                                <tr>
                                                    <TableCell>
                                                        <Label>Involvement</Label>
                                                        {arrestee && arrestee.involvement ? arrestee.involvement : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>Invl No</Label>
                                                        {arrestee && arrestee.invlNo ? arrestee.invlNo.replace(/"/g, '') : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>Name</Label>
                                                        {arrestee && arrestee.name ? arrestee.name : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>Sex</Label>
                                                        {arrestee && arrestee.sex ? arrestee.sex : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>Race</Label>
                                                        {arrestee && arrestee.race ? arrestee.race : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell width="100%">
                                                        <Label>Home Address</Label>
                                                        {arrestee && arrestee.address ? arrestee.address : '\u00A0'}
                                                    </TableCell>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Table key={index} cellPadding="2" cellSpacing="0">
                                            <tbody>
                                                <tr>
                                                    <TableCell>
                                                        <Label>HGT</Label>
                                                        {arrestee && arrestee.height ? arrestee.height : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>WGT</Label>
                                                        {arrestee && arrestee.weight ? arrestee.weight : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>HAIR</Label>
                                                        {arrestee && arrestee.hair ? arrestee.hair : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>EYE</Label>
                                                        {arrestee && arrestee.eyeColor ? arrestee.eyeColor : '\u00A0'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Label>Book #</Label>
                                                        {arrestee && arrestee.bookNumber ? arrestee.bookNumber : '\u00A0'}
                                                    </TableCell>
                                                    {arresteeRelatedOffenses.length > 0 ? (
                                                        arresteeRelatedOffenses.map((offense, index) => (
                                                            <TableCell key={index}>
                                                                <Label>Offense</Label>
                                                                {offense && offense.offense ? offense.offense : '\u00A0'}
                                                            </TableCell>
                                                        ))
                                                    ): (
                                                        <TableCell width="100%">
                                                            &nbsp;
                                                        </TableCell>
                                                    )}
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    );
                })
            )}
        </ThemeProvider>
    );
}

export default Arrestees;